const SDK_VERSION = "10.73.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
